import { isInside } from './isInside';
export class CalendarResizeHelper {
/**
 * @param {?} resizeContainerElement
 * @param {?=} minWidth
 */
constructor(
private resizeContainerElement: HTMLElement,
private minWidth?: number
  ) {}
/**
 * @param {?} __0
 * @return {?}
 */
validateResize({ rectangle }: { rectangle: ClientRect }): boolean {
    if (this.minWidth && rectangle.width < this.minWidth) {
      return false;
    }

    return isInside(
      this.resizeContainerElement.getBoundingClientRect(),
      rectangle
    );
  }
}

function CalendarResizeHelper_tsickle_Closure_declarations() {
/** @type {?} */
CalendarResizeHelper.prototype.resizeContainerElement;
/** @type {?} */
CalendarResizeHelper.prototype.minWidth;
}

